import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { Cards } from "./Cards";
import { allAwards } from "../AwardsData";  // ensure AwardsData.js exports allAwards

export default function SearchResults() {
  const { search } = useLocation();
  const query = new URLSearchParams(search).get("q")?.toLowerCase() || "";

  const [results, setResults] = useState([]);

  useEffect(() => {
    if (!query) return;

    // find matches in name or category
    const filtered = allAwards.filter(a =>
      a.htext?.toLowerCase().includes(query) ||
      a.category?.toLowerCase().includes(query)
    );

    // remove duplicates by htext title
    const unique = [...new Map(filtered.map(item => [item.htext, item])).values()];
    setResults(unique);
  }, [query]);

  return (
    <div style={{ textAlign: "center", paddingTop: "40px" }}>
      
      {/* Heading */}
      <h1 className="heading">Search Results</h1>
      <h3 style={{ marginTop: "10px" }}>
        Showing results for: <b>{query}</b>
      </h3>

      <br />

      {/* If no results */}
      {results.length === 0 ? (
        <h3 style={{ color: "red" }}>No results found</h3>
      ) : (
        <div 
          className="award-list"
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "20px",
            marginTop: "30px"
          }}
        >
          {results.map((award, i) => (
            <Cards
              key={i}
              htext={award.htext}
              ptext={award.ptext}
              img1={award.img1}
              ialt={award.ialt}
              btext="Learn More"
              modalContent={award.modalContent}
            />
          ))}
        </div>
      )}
    </div>
  );
}
